import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temp-banner',
  templateUrl: './temp-banner.component.html',
  styleUrls: ['./temp-banner.component.scss']
})
export class TempBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
